// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + (chunkId === 4902 ? "slick" : chunkId) + "." + {"4902":"c0a2fea39a88b3e35871","6318":"34ba459db561b771f768","9755":"0ea7a1f5d961e25c2ca1"}[chunkId] + ".js";
};